/* eslint-disable */
// @ts-nocheck

import { useEffect, useState } from 'react'

import noData10 from '@/assets/svgs/noData10.svg'
import noData11 from '@/assets/svgs/noData11.svg'
import noData2 from '@/assets/svgs/noData2.svg'
import noData3 from '@/assets/svgs/noData3.svg'
import noData4 from '@/assets/svgs/noData4.svg'
import noData5 from '@/assets/svgs/noData5.svg'
import noData6 from '@/assets/svgs/noData6.svg'
import noData7 from '@/assets/svgs/noData7.svg'
import noData8 from '@/assets/svgs/noData8.svg'
import noData9 from '@/assets/svgs/noData9.svg'

// Lista de nombres de archivos SVG en la carpeta src/assets/svgs
const svgFiles = [
  noData2,
  noData3,
  noData4,
  noData5,
  noData6,
  noData7,
  noData8,
  noData9,
  noData10,
  noData11,
]

interface Empty {
  title?: string
  subTitle?: string
  size?: 'xs' | 's' | 'm' | 'l'
}

const EmptyList = ({ title, subTitle, size }: Empty) => {
  const [svg, setSvg] = useState<string | null>(null)
  const [loaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    // Seleccionar un archivo SVG aleatorio
    const randomIndex = Math.floor(Math.random() * svgFiles.length)
    const selectedSvg = svgFiles[randomIndex]
    setSvg(selectedSvg)
    setTimeout(() => {
      setLoaded(true) // Indicar que la carga ha comenzado
    }, 100)
  }, [])

  if (!svg) {
    return <div>Cargando...</div>
  }

  return (
    <div
      className={`flex h-auto min-h-0 flex-1 flex-col items-center justify-center ${
        loaded ? 'opacity-100 transition-opacity duration-200' : 'opacity-0'
      } `}
    >
      <div className="flex min-h-0 max-w-24 flex-shrink items-center justify-center">
        <img
          alt="No hay datos svg"
          className="max-h-24 object-scale-down"
          src={svg}
        />
      </div>

      <p className="text-customBlue-500 py-2 text-sm font-thin">
        {title ?? 'No hay elementos que mostrar'}
      </p>
      {
        <p className="text-customBlue py-2 text-sm font-thin">
          {subTitle ?? ''}
        </p>
      }
    </div>
  )
}

export default EmptyList
